import AgGridWrapper from "./AgGridWrapper";

export default AgGridWrapper;
